import React, { useEffect } from 'react'
import { Flex } from '@fareye/ui'
import { Description, SubDescription } from '../styled/styled'
import { IFormConfig } from '../utility/types'
import { useTranslation } from '@fareye/common'
import { Timer } from './Timer'
import { useTimer } from '../hooks/useTimer'

export function Header({
  label,
  desc,
  styles,
  hideSubmitButtonTimer = 0,
  disableSubmit,
  setDisableSubmit
}: Partial<IFormConfig>) {
  const { t } = useTranslation()
  let newTime = hideSubmitButtonTimer
  const [timer, setTimer] = React.useState(0)
  const disableItemFromLocal = localStorage.getItem('disableTime') || 0
  const date = new Date()
  const timeDiff = date.getTime() - Number(disableItemFromLocal)
  if (timeDiff > 0 && timeDiff < hideSubmitButtonTimer) {
    newTime = hideSubmitButtonTimer - timeDiff
  } else {
    newTime = 0
  }

  React.useEffect(() => {
    disableSubmit &&
      !newTime &&
      setDisableSubmit &&
      setDisableSubmit((state: any) => !state)
  }, [newTime])
  const [changedTime] = useTimer((a: any) => {
    setTimer(a)
  }, newTime / 1000)

  return (
    <Flex style={styles ? styles.container : {}} column>
      <Flex>
        <Description variant="h6" style={styles ? styles.label : {}}>
          {label ? t(label) : ''}
        </Description>
        {newTime ? <Timer>{newTime}</Timer> : null}
      </Flex>
      <SubDescription variant="secondary" style={styles ? styles.desc : {}}>
        {desc ? t(desc) : ''}
      </SubDescription>
    </Flex>
  )
}
